module.exports = __webpack_public_path__ + "a825b58c11f6a160b3e214b0129f9e0c.fbx";